import { IAdmin, IEditor, IUser, IUserGroup } from "@/components/elements/plannerSettings/EditCalendar";
import { fieldType, orderTable, sortByTable } from  "@/interfaces/plannerSettings";

export interface permissionsUser {
    id:number,
    roleName:roleName, 
    operation: operationType
    type:type
}

export enum roleName {
    admin = "Admin",
    manager = "Manager",
    user = "User"
}

export enum operationType{
    add = "Add",
    remove = "Remove"
}

export enum type {
    group = "Group",
    user = "User"
}

export const tableOrder =  (collection:any, order:sortByTable) => {

    return [...collection].sort((a, b) => {

        let fielda = a[order.field];
        let fieldb = b[order.field];

        if (fielda === null){
            fielda = ""
        }

        if (fieldb === null){
            fieldb = ""
        }

        // Parse date
        if (order.fieldType === fieldType.date){
            fielda = new Date(a[order.field]);
            fieldb = new Date(b[order.field]);
        }

        // Descending
        if (order.order === orderTable.dsc){
            if (fielda < fieldb) {
                return -1;
            }
            else if (fielda > fieldb) {
                return 1;
            }   
        }

        // Ascending
        if (order.order === orderTable.asc){
            if (fielda > fieldb) {
                return -1;
            }
            else if (fielda < fieldb) {
                return 1;
            }   
        }

        return 0;
    });

}

export const buildUsersAndGroups = (selectedUsers:IUser[], selectedGroups:IUserGroup[], orginalUsers:IUser[], orginalGroups:IUserGroup[]) => {

    const allUsers:permissionsUser[] = [];

    // Add users
    selectedUsers.forEach(user => {
        
        // Dont add if already saved in DB
        if (!orginalUsers.find(userOrig => userOrig.id === user.id)){
            allUsers.push({
                "id": user.id,
                "roleName":roleName.user,
                "operation":operationType.add,
                "type": type.user
            })
        }
    })

    // Add groups
    selectedGroups.forEach(group => {

        // Dont add if already saved in DB
        if (!orginalGroups.find(groupOrig => groupOrig.id === group.id)){
            allUsers.push({
                "id": group.id,
                "roleName":roleName.user,
                "operation":operationType.add,
                "type": type.group
            })
        }
    })

    // Remove - if user or group no longer in selected modal but exists in DB then create remove request
    orginalUsers.forEach(user => {

        if (!selectedUsers.find(selUser => selUser.id === user.id)){
            allUsers.push({
                "id": user.id,
                "roleName":roleName.user,
                "operation":operationType.remove,
                "type": type.user
            })
        }

    })

    orginalGroups.forEach(group => {

        if (!selectedGroups.find(selGroup => selGroup.id === group.id)){
            allUsers.push({
                "id": group.id,
                "roleName":roleName.user,
                "operation":operationType.remove,
                "type": type.group
            })
        }
    })

    return allUsers
}

export const buildOverview = (admins: IAdmin[], editors: IEditor[], orginalAdmins:IAdmin[], orginalEditors:IEditor[]) => {

    const allUsers:permissionsUser[] = [];

    // Add admins
    admins.forEach(user => {
        
        // Dont add if already saved in DB
        if (!orginalAdmins.find(userOrig => userOrig.id === user.id)){
            allUsers.push({
                "id": user.id,
                "roleName":roleName.admin,
                "operation":operationType.add,
                "type": type.user
            })
        }
    })

    // Add editors
    editors.forEach(group => {

        // Dont add if already saved in DB
        if (!orginalEditors.find(groupOrig => groupOrig.id === group.id)){
            allUsers.push({
                "id": group.id,
                "roleName":roleName.manager,
                "operation":operationType.add,
                "type": type.user
            })
        }
    })

    // Remove - if user no longer in selected modal but exists in DB then create remove request
    orginalAdmins.forEach(user => {

        if (!admins.find(selUser => selUser.id === user.id)){
            allUsers.push({
                "id": user.id,
                "roleName":roleName.admin,
                "operation":operationType.remove,
                "type": type.user
            })
        }

    })

    orginalEditors.forEach(editorOrig => {

        if (!editors.find(selEditor => selEditor.id === editorOrig.id)){
            allUsers.push({
                "id": editorOrig.id,
                "roleName":roleName.manager,
                "operation":operationType.remove,
                "type": type.user
            })
        }
    })

    return allUsers
}

export const removeFromDisplay = (modalSelected:any[], displaySelected:any[]) => {

    // Remove from display view if item doesnt exist in modal selected
    return displaySelected.filter(item => modalSelected.find(item2 => item2.id === item.id));
}

export const removeDuplicates = (current:any[], selected:any[]) => {

   return [...current, ...selected].filter((v, i, a) => a.findIndex(v2 => (v2.id === v.id)) === i)
}

export const checkHasOverviewChanged = (admins: IAdmin[], editors: IEditor[], orginalAdmins:IAdmin[], orginalEditors:IEditor[]) => {

    // Compare orginal user set to current to see if the user has made changes
    if (admins.length !== orginalAdmins.length || editors.length !== orginalEditors.length){
        return true
    }

    for (const y of orginalAdmins){
        if (!admins.find(x => x.id === y.id)){
            return true
        }
    }

    for (const y of orginalEditors) {
        if (!editors.find(x => x.id === y.id)){
            return true
        }
    }

    return false
}

export const checkHasUsersGroupsChanged = (selectedUsers:IUser[], selectedGroups:IUserGroup[], orginalUsers:IUser[], orginalGroups:IUserGroup[]) => {

    // Compare orginal user set to current to see if the user has made changes
    if (selectedUsers.length !== orginalUsers.length || selectedGroups.length !== orginalGroups.length){
        return true
    }

    for (const y of orginalUsers){
        if (!selectedUsers.find(x => x.id === y.id)){
            return true
        }
    }
 
    for (const y of orginalGroups){
        if (!selectedGroups.find(x => x.id === y.id)){
            return true
        }
    }

    return false
}